import { createAction, props } from '@ngrx/store';
import { DailyReports, SummaryReports } from '../models/reports.models';

export const listPaginationDailyReports = createAction('[DailyReports] List DailyReports', props<{ query: string }>());
export const listPaginationDailyReportsSuccess = createAction(
  '[DailyReports] List DailyReports Success',
  props<{ paginationDailyReports: DailyReports[]; query: string; filteredDailyReportsTotalCount: number }>()
);

export const listPaginationDailyReportsFailure = createAction('[DailyReports] List DailyReports Failure');

export const listPaginationSummaryReports = createAction('[SummaryReports] List SummaryReports', props<{ query: string }>());
export const listPaginationSummaryReportsSuccess = createAction(
  '[SummaryReports] List SummaryReports Success',
  props<{ paginationSummaryReports: SummaryReports[]; query: string; filteredSummaryReportsTotalCount: number }>()
);
export const listPaginationSummaryReportsFailure = createAction('[SummaryReports] List SummaryReports Failure');
